<div class="row my-3 my-md-5 mx-3 mx-md-0">
  <div class="col-md-8 offset-md-2 col-12 justify-content-center">

    <div class="border rounded py-4 px-3">
      <h1 class="mat-h1 color-blue-cat mt-n2">Registro</h1>

      <div class="alert alert-primary">
        Sólo necesitamos unos datos para registrarte. Posteriormente podrás registrarte al curso.
      </div>

      <form [formGroup]="registroForm" (ngSubmit)="saveRegistro()">
        <div class="form-body">
          <div class="row">
            <mat-form-field class="col-12 col-md-4">
              <mat-label>Nombre</mat-label>
              <input matInput formControlName="nombre">
              <mat-error *ngIf="nombreNoValido">*Campo requerido</mat-error>
            </mat-form-field>
    
            <mat-form-field class="col-12 col-md-4">
              <mat-label>Apellido Paterno</mat-label>
              <input matInput formControlName="apPaterno">
              <mat-error *ngIf="apPaternoNoValido">*Campo requerido</mat-error>
            </mat-form-field>
    
            <mat-form-field class="col-12 col-md-4">
              <mat-label>Apellido Materno</mat-label>
              <input matInput formControlName="apMaterno">
              <mat-error *ngIf="apMaternoNoValido">*Campo requerido</mat-error>
            </mat-form-field>
          </div>
    
          <div class="row">
            <mat-form-field class="col-12 col-md-4">
              <mat-label>Correo electrónico</mat-label>
              <input type="email" matInput formControlName="correo">
              <mat-error *ngIf="correoNoValido">*Campo requerido</mat-error>
              <mat-error *ngIf="formatoCorreoNoValido">*El formato de correo no es válido</mat-error>
            </mat-form-field>
    
            <mat-form-field class="col-12 col-md-4">
              <mat-label>Teléfono</mat-label>
              <input type="tel" matInput (keypress)="validaNumeros($event)" formControlName="telefono" [maxlength]="10">
              <mat-error *ngIf="telefonoNoValido">*Campo requerido</mat-error>
            </mat-form-field>
    
            <mat-form-field class="col-12 col-md-4">
              <mat-label>Género</mat-label>
              <mat-select formControlName="genero">
                <mat-option value="H">Hombre</mat-option>
                <mat-option value="M">Mujer</mat-option>
                <mat-option value="O">Otro</mat-option>
              </mat-select>
              <mat-error *ngIf="generoNoValido">*Campo requerido</mat-error>
            </mat-form-field>
          </div>
    
          <div class="form-actions mt-3">
            <div class="text-center">
              <button mat-raised-button type="submit" class="btn-blue-cat mr-2" [disabled]="!registroForm.valid">
                Registrarme
              </button>
            </div>
          </div>
        </div>
      </form>

      
    </div>
  </div>
</div>